module.exports = __webpack_public_path__ + "img/Skilled.4709af7a.png";